<template>
  <div>
    <div class="dialog-footer" :style="{ 'margin-top': mt ? '24px' : '0'}">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterButtons',
  props: {
    mt: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      subscriptions: [],
      serviceTypes: [],
      pagination: {},

      error: null,
      loading: false
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer {
  margin-top: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  /deep/ {
    .el-button {
      width: 100%;

      font-weight: 500 !important;
      font-size: 14px !important;
      line-height: 22px !important;
      border-radius: 4px !important;

    }

    .el-button--primary {
      background-color: #43D3B3 !important;
      border-color: #43D3B3 !important;

      color: #fff !important;
    }

    .el-button--default {
      border: 1px solid #E4E7ED !important;
      align-items: center;
      text-align: center;
      color: #606266!important;
    }
  }

}

</style>
